module.exports = __webpack_public_path__ + "img/plant_4_small.77b778c6.webp";